// Info: Import NPM Dependancies
import axios from "axios";
import { useApiHeaders } from "./useApiHeaders";
import { useSelector, useDispatch } from "react-redux";
import { getAppSettings, setAuthToken } from "../store/sitecoreSlice";
import { setSessionToken, getSessionToken } from "./sessionStorage.utils";

// defining a custom error handler for all APIs
const errorHandler = (error: any) => {
  const statusCode = error.response?.status;

  if (error.code === "ERR_CANCELED") {
    error.message = "test message";
  }

  // logging only errors that are not 401
  if (statusCode && statusCode !== 401) {
    console.error(error);
  }

  //return Promise.reject(error)
};


const useAxios = ()=>{
  const { plainHeader } = useApiHeaders();
    const appSettings = useSelector(getAppSettings);
    const dispatch = useDispatch();
     const authenticationApi = axios.create();
   const applicationServiceApi = axios.create();

// registering the custom error handler to the
// "api" axios instance
axios.interceptors.response.use(undefined, (error: any) => {
  return errorHandler(error);
});

// Refresh Token Logic using Axios Interceptors



authenticationApi.interceptors.request.use(
  (config) => {
    const token = getSessionToken();
    if (token) {
      config.headers.Unauthtoken = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

authenticationApi.interceptors.response.use(
  (response) => response,
  async (error: any) => {
    if (error?.response?.status === 401) {
      const newToken = await refreshToken();
      if (newToken) {
        error.config.headers.Unauthtoken = `Bearer ${newToken}`;
        return authenticationApi.request(error.config);
      }
    }
    return Promise.reject(error);
  }
);
  const refreshToken = async () => {
    try {
      const response = await authenticationApi.request({
        url: `${appSettings.applicationBaseUrl}${appSettings.tokenAPI}`,
        method: "POST",
        headers: {
          ...plainHeader,
          "accept-language": "en",
        },
      });
  
      if (response?.data?.access_token) {
        const newToken = response?.data?.access_token;
        // dispatch(
        //   setAuthToken(
        //     `${response.data.token_type} ${response.data.access_token}`
        //   )
        // );
        setSessionToken(newToken as string);
        return newToken;
      }
    } catch (error) {
      console.error("Refresh Token API failed", error);
      return null;
    }
  };
  return {authenticationApi,applicationServiceApi}
}

export {useAxios}